import GoogleMeetServices from "../../../services/GoogleMeetService";
import { getValidGoogleAccessToken } from "../Auth/GoogleMeetAuthHelper";

const GoogleProvider = {
  async getValidAccessToken() {
    return getValidGoogleAccessToken();
  },

  async createMeeting(payload) {
    const token = await this.getValidAccessToken();
    if (!token) throw new Error("Google Meet not authenticated");
    
    return GoogleMeetServices.createUserMeeting(payload);
  },

  async updateMeeting(meetingId, payload) {
    const token = await this.getValidAccessToken();
    if (!token) throw new Error("Google Meet not authenticated");

    return GoogleMeetServices.updateUserMeeting(meetingId, payload);
  },

  async getUpcomingMeetings() {
    return GoogleMeetServices.getUpcomingMeetings();
  },

  async deleteMeeting(meetingId, token) {
    if (!token) throw new Error("Google Meet not authenticated");

    return GoogleMeetServices.deleteMeeting(meetingId, token);
  },
  
  async deleteExpiredMeetings(token) {
    if (!token) throw new Error("Google Meet not authenticated");

    return GoogleMeetServices.deleteExpiredMeetings(token);
  },

  getName() {
    return "Google Meet";
  }
};

export default GoogleProvider;
